import { useCallback } from 'react';
import { getUrlForMiniSite, MiniSiteMedialink } from '../../../../../api/medialink';
import { MedialinkDialogHeaderTags } from '../../../components/MedialinkDialogHeaderTags';
import { Module } from '../../../../../api/module';
import useThrowAsyncError from '../../../../../hooks/useThrowAsyncError';
import WeblinkModal from '../../components/modals/WeblinkModal';
import WebLinkTargets from '../../../../../constants/WeblinkTargets';

export default function useMiniSiteMedialink() {
  const handleError = useThrowAsyncError();

  const openMiniSiteMedialink = useCallback(
    async (medialink: MiniSiteMedialink, module: Module) => {
      try {
        const { url } = await getUrlForMiniSite(module.id, medialink.id);

        switch (medialink.miniSite.target) {
          case WebLinkTargets.MODAL:
            return (
              <WeblinkModal
                url={url}
                id="weblink-modal"
                name={medialink.name}
                weblinkInfo={medialink.miniSite}
                headerProps={{
                  title: medialink.name,
                  titleTooltip: medialink.name,
                  tags: <MedialinkDialogHeaderTags material={medialink} module={module} />,
                }}
              />
            );

          case WebLinkTargets.SAME_WINDOW:
            window.location.assign(url);
            break;

          case WebLinkTargets.NEW_WINDOW:
            window.open(url);
            break;
        }
      } catch (err) {
        handleError(err);
      }
    },
    [handleError],
  );

  return { openMiniSiteMedialink };
}
